import {get as _get} from 'lodash';
import {withRouter} from 'react-router';

import {withApollo} from 'react-apollo';
import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import * as formUtils from '@utils/forms';
import {showModal} from '@utils/modal';
import {convertToInt, filterDisabledEncodingJobProfiles, isUrlParamValid} from '@utils/helpers';

class ThirdPartyClientTunnelsForm extends DefaultForm {
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        const hasPlaceholderTunnel = _get(this.props.GraphQLOptionsData, 'hasThirdPartyClientTunnelPlaceholder', false);
        const thirdPartyClientTunnel = _get(this.props.GraphQLEntityData, 'thirdPartyClientTunnel', null);
        const thirdPartyClientTunnels = _get(this.props.GraphQLOptionsData, 'vtdTunnelsUnusedByClient', null);

        if (hasPlaceholderTunnel && thirdPartyClientTunnel && !this.state.tunnelLoad) {
            if (false === thirdPartyClientTunnel.is_placeholder_for_auto_assignment) {
                this.setField('is_placeholder_for_auto_assignment', {
                    disabled: true,
                    defaultValue: false,
                });
            }

            this.setState(() => ({
                tunnelLoad: true,
            }));
        }

        if (hasPlaceholderTunnel && !this.state.autoAssignmentsCountLoad && !this.props.formParams.id) {
            this.setField('is_placeholder_for_auto_assignment', {
                disabled: true,
                defaultValue: false,
            });
            this.setField('vtd_tunnel_id', {
                hidden: false,
            });
            this.setField('client_tp_tunnels', {
                hidden: false,
            });

            this.setState(() => ({
                autoAssignmentsCountLoad: true,
            }));
        }

        if (thirdPartyClientTunnel && thirdPartyClientTunnels && !this.state.dataEntitytLoading) {
            this.setField('vtd_tunnel_id', {
                defaultValue: thirdPartyClientTunnel.vtd_tunnel_id?.toString() || null,
                options: thirdPartyClientTunnels,
                hidden: thirdPartyClientTunnel.is_placeholder_for_auto_assignment,
            });
            this.setField('client_tp_tunnels', {
                hidden: thirdPartyClientTunnel.is_placeholder_for_auto_assignment,
            });
            this.setField('is_placeholder_for_auto_assignment', {
                defaultValue: thirdPartyClientTunnel.is_placeholder_for_auto_assignment,
            });
            this.setState(() => ({
                dataEntitytLoading: true,
            }));
        }

        if(thirdPartyClientTunnels && !this.state.fieldsUpdated && this.props.formParams.rerender) {
            const newValues = this.props.formParams;

            this.setField('name', {
                defaultValue: newValues.name,
            });
            this.setField('description', {
                defaultValue: newValues.description,
            });
            this.setField('is_placeholder_for_auto_assignment', {
                defaultValue: newValues.is_placeholder_for_auto_assignment,
            });
            this.setField('vtd_tunnel_id', {
                defaultValue: newValues.vtd_tunnel_id,
            });
            this.setField('encoding_job_profile', {
                defaultValue: newValues.encoding_job_profile,
            });

            this.setField('output_client_references', {
                defaultValue: JSON.stringify(newValues.encoding_job_profile),
            });

            this.setField('client_tp_tunnels', {
                hidden: newValues.is_placeholder_for_auto_assignment,
            });

            this.setState(() => ({
                fieldsUpdated: true,
            }));
        }

        if (!this.getIsLoading() && this.props.GraphQLOptionsData !== prevProps.GraphQLOptionsData) {
            this.setEncodingJobProfileOptions(
                this.props.GraphQLOptionsData.encodingJobProfiles,
                (null !== this.props.formParams.id)
                    ? this.props.GraphQLEntityData.thirdPartyClientTunnel.encoding_job_profile.id
                    : null
            );
        }
    }

    setEncodingJobProfileOptions = (data, selectedOption) => {
        this.setField('encoding_job_profile', {
            options: filterDisabledEncodingJobProfiles(data, selectedOption),
        });
    };

    componentDidMount() {
        super.componentDidMount();

        this.setState(() => ({
            defaultForm_formTitle: 'Add new Tunnel',
        }));

        this.setOnChangeCallback({
            is_placeholder_for_auto_assignment: (data) => {
                this.setField('vtd_tunnel_id', {
                    hidden: !data.value,
                    defaultValue: null,
                });
                this.setField('client_tp_tunnels', {
                    hidden: !data.value,
                });
            },
        });

        if (!isUrlParamValid(this.props.formParams.id)) {
            return showModal({
                isVisible: true,
                content: formUtils.renderModalError('Tunnels',
                    getLink('clients.products.thirdParty.tunnels.index', {
                        id: this.props.formParams.clientId,
                    })
                ),
            });
        }

    }

    prepareDataForSubmit = (data) => {
        const references = JSON.parse(data.output_client_references).map((item) => delete item.__typename && item);

        return {
            id: data.id || null,
            client_product_third_party: this.props.formParams.thirdParty,
            name: data.name,
            description: data.description || '',
            encoding_job_profile: convertToInt(data.encoding_job_profile),
            is_placeholder_for_auto_assignment: data.is_placeholder_for_auto_assignment || false,
            vtd_tunnel_id: convertToInt(data.vtd_tunnel_id) || null,
            output_references: !data.is_placeholder_for_auto_assignment ? references : [],
        };

    };

    renderErrors() {
        this.props.Modal.setModal({
            isVisible: true,
            content: formUtils.renderModalError(
                'Third Party Tunnel',
                getLink('clients.products.thirdParty.tunnels.index', {
                    id: this.props.formParams.clientId || null,
                    thirdPartyClientTunnelStorageId: this.props.formParams.thirdPartyClientTunnelStorageId || null,
                }),
                'Tunnel not found.'
            ),
        });
    }
}

export default withRouter(withApollo(ThirdPartyClientTunnelsForm));
